/**
 * Created by udengale on 10.27.2014.
 */

define('paychex.app.messages/services/MessageListPdfGenerationService',[
    'angular',
    'htmlregistry',
    'lodash',
    'paychex.core/Logger',
    'paychex.core/Tracker',
    'paychex.core/native/PluginManager',
    'paychex.core/Errors'

], function (angular,
             htmlregistry,
             _,
             Logger,
             Tracker,
             PluginManager,
             Errors) {

    'use strict';

    var ngDependencies = [
            '$q',
            'PdfGenerationService',
            '$templateCache'
        ],

        /**
         * @class paychex.app.landing.shared.messageList.MessageListPdfGenerationService
         * @param {promise} $q - AngularJS promise
         * @param {service} PdfGenerationService - used to generate the PDF
         * @param {service} $templateCache - loads the template into cache for quicker access
         * @description Handles any pdf generation for messages
         */
        Constructor = function ($q, PdfGenerationService, $templateCache) {

            var logger = Logger.get('paychex.app.landing.shared.messages.MessagesListPdfGenerationService', {level: 'ALL'}),
                generalText = 'General';
            /*            TranslationService.translate('png.landing.messages.general').then(function(text){
             generalText = text;
             });*/

            /**
             * @ngdoc method
             * @memberOf paychex.app.landing.shared.messageList.MessageListPdfGenerationService
             * @param {array} messageList - An array of messages to convert into pdf
             * @param {object} messageGroup - The message group that the message list is associated with
             * @description  Takes an array of messages to print to pdf, and passes the messages and the requireJS messageTemplate
             * to the PdfGenerationService
             */
            function generateMessagesPdf(messageList, messageGroup) {
                Tracker.marks.start('Generate Message PDFs', {
                    category: 'ListPanel: Messages',
                    numMessages: messageList.length
                });
                logger.info('Inside MessageListPdfGenerationService.generateMessagesPdf()');
                var messages = [],
                    hasName = null,
                    hasId = null,
                    templatePath = $templateCache.get(htmlregistry.paths['paychex.app.messages'] + '/templates/messages-print.tpl.html');

                _.forEach(messageList, function setMessageParameters(msg) {
                    if (!_.isNil(msg)) {
                        // Can't use msg directly because we're modifying it
                        var msgCopy = _.clone(msg),
                            companyID;
                        hasName = (!_.isNil(msg.companyLegalName) && msg.companyLegalName.trim().length > 0);
                        hasId = (!_.isNil(msg.company) && msg.company.trim().length > 0);
                        if (msg.messagePlatform !== 'HRIS') {
                            companyID = msg.company;
                        } else {
                            companyID = messageGroup.clientId;
                        }
                        if (hasName && hasId) {
                            msgCopy.companyLegalName += ' ( ' + companyID + ' ) ';
                        } else {
                            msgCopy.companyLegalName = generalText;
                        }
                        messages.push(msgCopy);
                    }
                });
                // Call PdfGenerationService to generate pdf

                PdfGenerationService.generatePdf(messages, templatePath)
                    .then(function firePluginManager(pdf) {
                        return PluginManager.firePluginEvent('fileOpener.base64Open', {
                            blobString: pdf,
                            name: 'Messages.pdf',
                            type: 'application/pdf'
                        }, false)
                            .then(function hasKeyHandler(result) {
                                logger.info('MessageListPdfGenerationService returning from pdf viewing.  result:' + result.success + ' ' + result.errMsg);
                                if (!result.success) {
                                    logger.error('Had problems firing the plugin event to show a pdf message.  Error: ' + result.errMsg);
                                }
                                return result;
                            });
                    })
                    .finally(function trackerEvent() {
                        Tracker.marks.stop('Generate Message PDFs', {
                            category: 'ListPanel: Messages',
                            numMessages: messageList.length
                        });
                    })
                    .catch(function errorHandler(error) {
                        logger.error('Had problems generating or firing the PDFGenerationService event for message.  Error: ' + error);
                        Errors.throw(error, 'PDFGenerationService message event failed', {arguments: [messages, templatePath], severity: 'NONE'});
                        // This is not standard, we don't bubble this as a CUE.
                    })
                    .done();
            }

            return {generateMessagesPdf: generateMessagesPdf};
        };

    // Inject!
    Constructor.$inject = ngDependencies;

    return Constructor;

});


